import AxiosInstance from "../config/axiosInterceptor";
import {ContentApiRoutes} from "../../navigation/NavConstant";

export const ResetPasswordServices = {
  generateLink: (params: any) => AxiosInstance.post(ContentApiRoutes.RESET_PASSWORD_LINK, params),
  validateToken: (params: any) => AxiosInstance.post(ContentApiRoutes.VALIDATE_PASSWORD_TOKEN, params),
  resetPassword: (params: any) => AxiosInstance.post(ContentApiRoutes.RESET_PASSWORD_TOKEN, params),
};
